module.exports = Backbone.View.extend({
	template: require('./linkable-image-container-preview-template')
})
